import { Icon, View } from "@aws-amplify/ui-react";

export default function SymptomsIcon({ isValid = true }) {
  return (
    <>
      <Icon
        width="50px"
        height="50px"
        viewBox={{ minX: 0, minY: 0, width: 50, height: 50 }}
        paths={[
          {
            d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
            fill: "rgba(33,208,195,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0%"
        bottom="0%"
        left="0%"
        right="0%"
      ></Icon>
      <Icon
        width="22.11px"
        height="48.29px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 22.1104793548584,
          height: 48.29051971435547,
        }}
        paths={[
          {
            d: "M3.62564 37.5018C3.62564 37.5018 1.73873 42.0839 1.66012 46.5146C4.52623 47.6595 7.65318 48.2905 10.928 48.2905C13.7206 48.2905 16.4057 47.831 18.9134 46.9861C18.8791 46.785 18.846 46.6066 18.8145 46.4574C18.2251 43.6568 17.93 42.0355 17.93 42.0355C17.93 42.0355 18.323 39.431 18.1512 38.1783C17.9792 36.9255 18.0038 33.83 18.5443 32.405C19.0847 30.9802 19.8706 27.0005 20.1656 23.9542C20.4603 20.9079 21.1972 18.844 22.0328 17.6157C22.8681 16.3877 16.7102 14.3518 15.9243 14.5484C15.138 14.7448 13.5298 13.9657 13.5298 13.9657L12.6527 13.2859L11.7109 10.249C11.7109 10.249 12.1564 9.67421 12.5215 8.82919C12.5215 8.82919 13.0204 8.75849 13.2044 8.47616C13.3886 8.19355 13.831 6.46161 13.7573 5.89667C13.7203 5.61259 13.3882 5.6454 13.067 5.74794C13.0757 4.07187 12.7213 1.29794 10.4116 0.393938C7.02096 -0.932527 5.23941 1.51611 5.23941 1.51611C5.23941 1.51611 4.24449 2.90439 4.41646 4.57489C4.58834 6.2456 4.63756 6.73661 4.63756 6.73661C4.63756 6.73661 3.91402 6.31249 3.8526 7.0496C3.79117 7.78671 4.73248 9.28866 4.80621 9.41152C4.87994 9.53437 5.30357 9.33153 5.30357 9.33153C5.30357 9.33153 5.65396 10.3878 5.85035 10.6336C6.04693 10.8791 6.15123 10.9284 6.15123 10.9284C6.15123 10.9284 6.90074 13.5629 6.90074 13.8333C6.90074 14.1035 4.10006 15.9212 3.51031 16.0687C3.22096 16.1412 2.10836 16.1426 0.789119 16.4738C-0.530217 16.8052 0.203377 18.1078 0.203377 18.1078C0.203377 18.1078 0.688632 21.5102 1.25377 22.8123C1.81881 24.1143 3.29273 27.5781 4.42281 28.9785C5.55269 30.3789 5.02633 33.074 5.02633 33.074L3.62564 37.5018Z",
            fill: "rgba(255,91,98,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="3.42%"
        bottom="0%"
        left="28.14%"
        right="27.64%"
      ></Icon>
      <View
        padding="0px 0px 0px 0px"
        width="9.34px"
        height="34.28px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="31.41%"
        bottom="0.03%"
        left="35.79%"
        right="45.53%"
      >
        <Icon
          width="1.01px"
          height="4.06px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 1.0088176727294922,
            height: 4.063770294189453,
          }}
          paths={[
            {
              d: "M0.999639 4.06357L1.00882 4.06377C0.0344036 3.19072 0.195146 0.558789 0.42249 0C-0.169307 1.15674 -0.0985055 2.70586 0.381573 3.6874C0.435479 3.79756 0.331572 3.93106 0.219365 4.025C0.478447 4.04199 0.738408 4.05478 0.999639 4.06357Z",
              fill: "rgba(237,76,84,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.15%"
          bottom="0%"
          left="56.21%"
          right="32.99%"
        ></Icon>
        <Icon
          width="5.55px"
          height="21.66px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 5.545172691345215,
            height: 21.662981033325195,
          }}
          paths={[
            {
              d: "M1.41952 5.7293C1.41952 5.7293 0.48524 5.24258 0.190611 5.44532C-0.103822 5.64824 0.0932472 5.94571 0.486411 6.0878C0.879868 6.23008 1.03377 6.34278 1.43944 6.58008C1.68153 6.72168 2.10936 6.68526 2.35077 6.54297C2.75536 6.30459 2.7743 6.2211 3.16717 6.07764C3.55995 5.93399 3.75565 5.63633 3.46073 5.43438C3.16532 5.23242 2.27567 5.68604 2.27567 5.68604C2.03085 5.78799 1.66463 5.81651 1.41952 5.7293ZM0.29774 0.0744167C0.0759629 0.241604 0.270982 0.469925 0.588951 0.544046C0.906822 0.617972 1.0371 0.691311 1.37362 0.837601C1.5744 0.924808 1.81942 0.984574 1.99217 0.85264C2.28192 0.631254 2.50409 0.602835 2.79383 0.456058C3.09403 0.304105 3.08876 0.161136 2.98446 0.0677767C2.87743 -0.0278287 2.66083 -0.0683558 2.16161 0.266703C1.55712 0.68057 0.587877 -0.144138 0.29774 0.0744167ZM1.30731 1.40235C1.30731 1.40235 0.458775 0.971488 0.19481 1.15704C-0.069545 1.34288 0.111607 1.60977 0.46815 1.73467C0.825084 1.85938 0.96522 1.96006 1.33397 2.1708C1.55389 2.2961 1.94012 2.25957 2.15682 2.12901C2.5204 1.90977 2.53612 1.83418 2.88973 1.70098C3.24315 1.56797 3.41737 1.29707 3.14872 1.11739C2.88016 0.937503 2.08075 1.35567 2.08075 1.35567C1.86053 1.44961 1.52977 1.47862 1.30731 1.40235ZM1.37001 2.7294C1.37001 2.7294 0.436216 2.24297 0.14149 2.446C-0.152846 2.64893 0.044127 2.9459 0.437486 3.08789C0.830553 3.23037 0.98485 3.34336 1.39051 3.58067C1.63212 3.72217 2.06053 3.68584 2.30174 3.54327C2.70663 3.30489 2.72518 3.22159 3.11796 3.07803C3.51083 2.93448 3.70702 2.63633 3.4117 2.43477C3.11649 2.23272 2.22674 2.68633 2.22674 2.68633C1.98163 2.78858 1.61542 2.8168 1.37001 2.7294ZM1.44393 4.30098C1.44393 4.30098 0.509459 3.81446 0.215416 4.01739C-0.0793108 4.22012 0.11776 4.51709 0.511119 4.65948C0.904381 4.80166 1.05838 4.91465 1.46415 5.15196C1.70594 5.29326 2.13407 5.25703 2.37538 5.11465C2.78026 4.87627 2.79901 4.79268 3.19159 4.64922C3.58446 4.50567 3.78026 4.20782 3.48534 4.00625C3.18983 3.8043 2.30028 4.25782 2.30028 4.25782C2.05536 4.35967 1.68905 4.38799 1.44393 4.30098ZM3.34823 20.695C3.34823 20.695 2.44032 20.1636 2.13563 20.352C1.83114 20.5402 2.01239 20.8466 2.39774 21.0079C3.53837 21.4841 3.63749 21.6785 3.76844 21.662C3.89012 21.6468 4.03934 21.4496 5.07548 21.128C5.47538 21.0039 5.68631 20.7156 5.40184 20.4998C5.11747 20.2838 4.20575 20.6938 4.20575 20.6938C3.95604 20.7835 3.58856 20.7941 3.34823 20.695ZM3.36053 19.3262C3.36053 19.3262 2.45262 18.7949 2.14823 18.983C1.84325 19.1713 2.02469 19.478 2.41024 19.6389C2.7954 19.8002 2.94354 19.9203 3.33631 20.177C3.57049 20.33 4.00018 20.3145 4.24852 20.1841C4.66542 19.9655 4.68807 19.8829 5.08788 19.7591C5.48768 19.6346 5.69872 19.3465 5.41425 19.1308C5.12997 18.915 4.21796 19.3247 4.21796 19.3247C3.96805 19.4146 3.60116 19.4252 3.36053 19.3262ZM3.39979 17.8114C3.39979 17.8114 2.39354 17.4864 2.13905 17.7348C1.88465 17.9833 2.13094 18.2437 2.54354 18.3188C2.95604 18.394 3.12762 18.4797 3.56903 18.6464C3.83241 18.7457 4.24784 18.6395 4.46053 18.4591C4.81737 18.1571 4.82098 18.072 5.1829 17.8657C5.54481 17.6593 5.68534 17.3334 5.35887 17.1834C5.03231 17.0333 4.23553 17.6275 4.23553 17.6275C4.01249 17.7679 3.65663 17.8568 3.39979 17.8114ZM3.01639 16.2279C3.01639 16.2279 2.08202 15.7415 1.78758 15.944C1.49315 16.1473 1.69012 16.4444 2.08339 16.5865C2.47674 16.7288 2.63075 16.8414 3.03641 17.0788C3.27821 17.2205 3.70604 17.184 3.94764 17.0417C4.35253 16.8034 4.37098 16.7198 4.76405 16.5762C5.15682 16.4329 5.35262 16.135 5.05751 15.9332C4.76209 15.7313 3.87264 16.1851 3.87264 16.1851C3.62772 16.2866 3.26132 16.3152 3.01639 16.2279ZM2.57401 14.7639C2.57401 14.7639 1.63993 14.2774 1.34559 14.48C1.05077 14.6829 1.24774 14.9802 1.64129 15.1223C2.03456 15.2647 2.18856 15.3774 2.59432 15.6148C2.83592 15.7564 3.26425 15.72 3.50536 15.5775C3.91034 15.3391 3.92889 15.2556 4.32176 15.1121C4.71454 14.9685 4.91053 14.6708 4.61522 14.4689C4.3202 14.2669 3.43065 14.7205 3.43065 14.7205C3.18553 14.8225 2.81903 14.8511 2.57401 14.7639ZM2.24237 13.1927C2.24237 13.1927 1.30829 12.7063 1.01366 12.9089C0.719126 13.1119 0.916002 13.4091 1.30965 13.5513C1.70272 13.6936 1.85682 13.8064 2.26258 14.0438C2.50428 14.1851 2.93231 14.1488 3.17372 14.0064C3.5786 13.768 3.59715 13.6846 3.98993 13.541C4.38289 13.3976 4.5787 13.0996 4.28368 12.8978C3.98856 12.6958 3.09891 13.1496 3.09891 13.1496C2.85379 13.2516 2.48768 13.2795 2.24237 13.1927ZM2.00917 11.6213C2.00917 11.6213 1.07499 11.1349 0.780358 11.3374C0.485924 11.5404 0.682701 11.8377 1.07616 11.9799C1.46942 12.1221 1.62352 12.235 2.02909 12.4721C2.27089 12.6137 2.69921 12.5775 2.94061 12.4351C3.34549 12.1967 3.36395 12.1132 3.75682 11.9697C4.14969 11.8261 4.3454 11.528 4.05057 11.3265C3.75516 11.1244 2.86551 11.5782 2.86551 11.5782C2.62049 11.6802 2.25428 11.7085 2.00917 11.6213ZM1.78797 10.0978C1.78797 10.0978 0.853697 9.61153 0.559068 9.81416C0.26483 10.017 0.461705 10.3143 0.855065 10.4564C1.24842 10.5986 1.40243 10.7112 1.80819 10.9486C2.04989 11.0902 2.47821 11.0538 2.71942 10.9116C3.1243 10.6731 3.14276 10.5897 3.53563 10.4463C3.9285 10.3027 4.1245 10.0047 3.82928 9.80303C3.53407 9.60098 2.64452 10.0548 2.64452 10.0548C2.3993 10.1565 2.03309 10.185 1.78797 10.0978ZM1.71434 8.64532C1.71434 8.64532 0.780064 8.15909 0.485631 8.36182C0.191099 8.56455 0.388268 8.86192 0.781432 9.00401C1.1746 9.1461 1.3286 9.25908 1.73436 9.49668C1.97645 9.6377 2.40428 9.60147 2.64559 9.45928C3.05047 9.2208 3.06922 9.13711 3.4619 8.99385C3.85487 8.8503 4.05067 8.55244 3.75555 8.35069C3.46043 8.14864 2.57059 8.60235 2.57059 8.60235C2.32587 8.7042 1.95946 8.73252 1.71434 8.64532ZM1.48094 7.19356C1.48094 7.19356 0.54647 6.70713 0.252427 6.90967C-0.0420063 7.1125 0.154771 7.40987 0.54813 7.55186C0.941392 7.69414 1.09549 7.80684 1.50096 8.04434C1.74305 8.18584 2.17118 8.14942 2.41229 8.00723C2.81737 7.76885 2.83583 7.68526 3.2286 7.5417C3.62137 7.39825 3.81718 7.1003 3.52225 6.89883C3.22723 6.69678 2.33749 7.15049 2.33749 7.15049C2.09237 7.25196 1.72626 7.28067 1.48094 7.19356Z",
              fill: "rgba(237,76,84,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="36.8%"
          left="40.65%"
          right="0%"
        ></Icon>
        <Icon
          width="7.29px"
          height="6.84px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 7.29291296005249,
            height: 6.844335556030273,
          }}
          paths={[
            {
              d: "M0 4.60879L2.57949 6.10732L5.65029 6.84434C5.65029 6.84434 5.65029 6.47578 5.45371 6.26709C5.25723 6.0583 2.98486 5.06338 2.98486 5.06338L2.28477 4.57207L4.09033 5.23545L7.17373 5.56719C7.17373 5.56719 7.39463 5.32158 7.23496 5.06328C7.07539 4.80557 4.86445 4.4002 4.86445 4.4002L2.80068 3.60166L2.56729 3.30674L4.64307 4.00723C4.64307 4.00723 6.58398 4.26484 6.76826 4.19111C6.95244 4.11738 6.79258 3.68769 6.79258 3.68769L4.51992 2.85244L2.85537 2.21992L2.85537 1.98027L3.80752 2.31836L5.96348 2.61289C5.96348 2.61289 6.31963 2.49014 6.06152 2.1461C5.80361 1.80215 3.74609 1.27422 3.74609 1.27422C3.74609 1.27422 3.48809 1.04082 2.13701 0.340527C1.84883 0.191113 1.52861 0.0810547 1.20332 0L0 4.60879Z",
              fill: "rgba(237,76,84,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="55.65%"
          bottom="24.38%"
          left="0%"
          right="21.94%"
        ></Icon>
      </View>
      <View
        padding="0px 0px 0px 0px"
        width="41.67px"
        height="35.64px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="7.5%"
        bottom="21.22%"
        left="5.98%"
        right="10.68%"
      >
        <Icon
          width="16.11px"
          height="21.19px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 16.106348037719727,
            height: 21.1904296875,
          }}
          paths={[
            {
              d: "M11.7966 0C10.4449 0.349902 8.89092 1.0501 7.78496 2.52451C7.78496 2.52451 3.8544 4.83359 2.13438 7.88008C0.414649 10.9266 -0.666308 11.909 0.463966 13.3831C1.59395 14.8573 10.9047 17.7562 11.4942 18.1002C12.008 18.3998 12.8342 19.2638 13.0381 19.481L14.9028 21.1904L16.1063 16.5818C14.9068 16.2832 13.6374 16.382 13.6374 16.382C13.6374 16.382 13.3181 16.4313 12.1145 15.4729C10.9104 14.5149 4.8917 11.1247 4.8917 11.1247C4.8917 11.1247 6.0957 10.5595 7.27471 9.84726C8.45391 9.13496 12.3337 6.32041 12.3337 6.32041C12.3337 6.32041 13.0974 4.90947 13.8343 2.96875C14.5718 1.02744 11.7966 0 11.7966 0Z",
              fill: "rgba(255,91,98,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="40.55%"
          bottom="0%"
          left="0%"
          right="61.34%"
        ></Icon>
        <Icon
          width="22.72px"
          height="24.57px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 22.716567993164062,
            height: 24.572895050048828,
          }}
          paths={[
            {
              d: "M12.6248 19.6601C12.996 17.8149 13.5532 16.4727 14.1634 15.5757C14.9987 14.3477 19.6909 10.515 20.3787 8.10737C21.0668 5.70015 22.2703 3.98013 22.5651 3.12036C22.86 2.2604 22.9092 0.0494628 20.9439 0.000439348C18.9783 -0.0487794 7.99696 4.05376 7.99696 4.05376L6.4493 4.44702C6.4493 4.44702 5.58426 4.5603 5.20243 4.92817L5.10985 5.03638L3.64706 6.69399L1.70584 7.74868C1.70584 7.74868 0.625181 7.82388 0.674302 8.19253C0.723423 8.56118 1.89442 8.37827 1.89442 8.37827L3.55487 7.81763L2.02762 8.58189C2.02762 8.58189 0.318052 8.8436 0.269028 8.97847C0.220005 9.11333 0.246079 9.53198 0.504086 9.50737C0.762094 9.48276 2.88534 9.22437 2.88534 9.22437L4.19969 8.85571L2.62733 9.65405C2.62733 9.65405 0.0846532 9.93667 0.0232275 10.207C-0.0381983 10.4773 0.0232275 10.7351 0.195395 10.7965C0.36727 10.858 2.92215 10.6613 2.92215 10.6613L4.88778 9.87534L3.2286 10.8663L0.920005 11.2879C0.920005 11.2879 0.817076 11.8499 1.21014 11.9233C1.60321 11.9967 3.6745 11.7345 3.6745 11.7345L6.11073 10.6913C6.11073 10.6913 7.73583 8.88247 7.87079 8.18228C8.00575 7.48208 8.13602 7.33794 8.46766 7.04321C8.7993 6.74849 8.86688 6.9019 8.86688 6.9019L15.3156 5.41567C15.3156 5.41567 14.5662 6.22642 14.2098 6.93882C13.8537 7.65132 10.3528 8.7564 9.66493 10.3288C8.46346 13.0746 7.66981 12.6632 5.66034 11.9257C5.66034 11.9257 4.01112 13.3296 3.99725 13.8839C3.92547 16.707 5.35789 24.2406 5.49315 24.3218C5.65516 24.4189 9.99842 26.0292 12.6248 19.6601Z",
              fill: "rgba(255,91,98,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="31.06%"
          left="45.48%"
          right="0%"
        ></Icon>
      </View>
      <Icon
        width="5.83px"
        height="7.34px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 5.830508232116699,
          height: 7.3440842628479,
        }}
        paths={[
          {
            d: "M5.83051 0C5.59975 0.0751953 5.35434 0.18457 5.19398 0.339063L5.10141 0.447266L3.63861 2.10488L1.85531 3.07373C1.7019 3.15703 0.801993 3.18223 0.597305 3.37451C0.0158598 3.92061 1.76625 3.82959 1.94662 3.76865L3.54623 3.22871L2.01898 3.99297C2.01898 3.99297 0.252285 4.31807 0.203262 4.45303C0.154238 4.58799 0.140371 4.92842 0.398379 4.90391C0.656387 4.87939 2.35648 4.83848 2.35648 4.83848L4.04623 4.30752L3.83285 3.62002C3.83285 3.62002 4.27836 3.04521 4.6435 2.2002C4.6435 2.2002 5.14232 2.12949 5.32631 1.84717C5.45668 1.64727 5.71586 0.724023 5.83051 0ZM4.05512 4.33594L2.37797 5.1792C2.37797 5.1792 0.0763086 5.34766 0.0148828 5.61787C-0.046543 5.88818 0.0911523 6.01924 0.263223 6.08066C0.435195 6.14209 2.71713 6.04062 2.71713 6.04062L4.40834 5.47461L4.05512 4.33594ZM4.43266 5.55313L3.22016 6.27725L1.05932 6.67197C0.965177 6.68916 0.898379 6.77002 0.899453 6.86572C0.901211 7.0375 0.949063 7.28721 1.2017 7.33437C1.59467 7.40771 3.57201 7.0415 3.57201 7.0415L4.78646 6.66582L4.77484 6.65684L4.43266 5.55313Z",
            fill: "rgba(237,76,84,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="16.68%"
        bottom="68.63%"
        left="43.9%"
        right="44.44%"
      ></Icon>
      <Icon
        width="8.68px"
        height="8.68px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 8.676756858825684,
          height: 8.6767578125,
        }}
        paths={[
          {
            d: "M4.33838 2.03701C5.60938 2.03701 6.63955 3.06719 6.63955 4.33818C6.63955 5.60918 5.60928 6.63935 4.33838 6.63935C3.06738 6.63935 2.03721 5.60908 2.03721 4.33818C2.03721 3.06738 3.06738 2.03701 4.33838 2.03701ZM4.33838 0C5.53545 0 6.61953 0.485742 7.40469 1.2707L7.40605 1.27207C8.19082 2.05713 8.67676 3.1416 8.67676 4.33838C8.67676 5.53545 8.19102 6.61953 7.40605 7.40469L7.40469 7.40605C6.61963 8.19082 5.53545 8.67676 4.33838 8.67676C3.1417 8.67676 2.05723 8.19101 1.27207 7.40605L1.2707 7.40469C0.485938 6.61963 0 5.53545 0 4.33838C0 3.1417 0.485743 2.05723 1.2707 1.27207L1.27207 1.2707C2.05713 0.485742 3.1417 0 4.33838 0ZM6.93389 1.74277C6.26992 1.07939 5.35234 0.668847 4.33848 0.668847C3.32461 0.668847 2.40703 1.07939 1.74307 1.74277C1.07969 2.40674 0.669141 3.32441 0.669141 4.33818C0.669141 5.35215 1.07969 6.26963 1.74307 6.93359C2.40703 7.59697 3.32471 8.00752 4.33848 8.00752C5.35244 8.00752 6.26992 7.59697 6.93389 6.93359C7.59727 6.26963 8.00781 5.35205 8.00781 4.33818C8.00772 3.32441 7.59727 2.40684 6.93389 1.74277Z",
            fill: "rgba(254,254,254,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="24.41%"
        bottom="58.23%"
        left="32.95%"
        right="49.69%"
      ></Icon>
      <Icon
        width="1.84px"
        height="4.89px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 1.8391609191894531,
          height: 4.88740348815918,
        }}
        paths={[
          {
            d: "M0.128613 0C0.0634767 0.529492 0.228223 1.85254 0 2.21465C0.583984 3.07168 1.26436 3.69277 1.83916 4.8874C1.22119 3.53301 0.610059 2.13906 0.128613 0Z",
            fill: "rgba(237,76,84,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="45.31%"
        bottom="44.92%"
        left="29.69%"
        right="66.63%"
      ></Icon>
      <Icon
        width="5.97px"
        height="5.97px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 5.97255802154541,
          height: 5.97255802154541,
        }}
        paths={[
          {
            d: "M2.98633 1.40224C3.86123 1.40224 4.57041 2.11152 4.57041 2.98633C4.57041 3.86113 3.86113 4.57041 2.98633 4.57041C2.11152 4.57041 1.40225 3.86113 1.40225 2.98633C1.40225 2.11152 2.11142 1.40224 2.98633 1.40224ZM2.98633 0C3.81035 0 4.55664 0.334375 5.09707 0.874707C5.65908 1.43672 5.97256 2.1914 5.97256 2.98633C5.97256 3.81035 5.63818 4.55664 5.09785 5.09707C4.53574 5.65918 3.78125 5.97256 2.98623 5.97256C2.1624 5.97256 1.41592 5.63818 0.875488 5.09795C0.313379 4.53584 0 3.78135 0 2.98633C0 2.1625 0.334374 1.41601 0.874609 0.875583C1.43672 0.313572 2.1914 0 2.98633 0ZM4.77295 1.1997C4.31592 0.743064 3.68437 0.460449 2.98642 0.460449C2.28857 0.460449 1.65693 0.743064 1.1999 1.1997C0.74326 1.65674 0.460644 2.28847 0.460644 2.98623C0.460644 3.68418 0.74326 4.31572 1.1999 4.77275C1.65693 5.22939 2.28857 5.51201 2.98642 5.51201C3.68437 5.51201 4.31592 5.22939 4.77295 4.77275C5.22959 4.31572 5.51221 3.68418 5.51221 2.98623C5.51211 2.28847 5.22959 1.65674 4.77295 1.1997Z",
            fill: "rgba(254,254,254,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="73.28%"
        bottom="14.77%"
        left="48.13%"
        right="39.93%"
      ></Icon>
      <Icon
        width="4.06px"
        height="2.01px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 4.0583014488220215,
          height: 2.01416015625,
        }}
        paths={[
          {
            d: "M0.362402 1.59062C0.705566 1.6084 2.21592 1.2793 3.14463 0.634473L4.0583 0C2.85723 1.26387 1.81064 1.78447 0 2.01416C0.204883 1.76094 0.362402 1.59062 0.362402 1.59062Z",
            fill: "rgba(237,76,84,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="15.15%"
        bottom="80.82%"
        left="73.79%"
        right="18.09%"
      ></Icon>
    </>
  );
}
